import { render, staticRenderFns } from "./NavigationMyPageIconParts.vue?vue&type=template&id=e84ce980"
import script from "./NavigationMyPageIconParts.vue?vue&type=script&lang=ts"
export * from "./NavigationMyPageIconParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports